/* import __COLOCATED_TEMPLATE__ from './additional-seat-removal-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();